import { MATCH_FILTER_KEYS } from "../utils/constant";

function isExpired(match) {
  const now = new Date();
  const updated = new Date(match.updated);
  const diff = now.getTime() - updated.getTime();
  const minutes = diff / (1000 * 60);
  return minutes > 2;
}

export default {
  SET_MATCH_GENERAL_DATA(state, matches) {
    state.match.list = matches.map((match) => ({
      ...match,
      updated: new Date(),
    }));
  },

  SET_MATCH_ODDS(state, odds) {
    odds.forEach((odd) => {
      if (!odd) return;
      const matchIndex = state.match.list.findIndex(
        (item) => item.id === odd.matchId,
      );

      if (matchIndex !== -1) {
        if (!state.match.list[matchIndex].data) {
          state.match.list[matchIndex].data = [];
        }

        const oddIndex = state.match.list[matchIndex].data.findIndex(
          (item) => item.companyId === odd.companyId,
        );

        if (oddIndex !== -1) {
          state.match.list[matchIndex].data[oddIndex] = odd;
        } else {
          state.match.list[matchIndex].data.push(odd);
        }
      }
    });
  },

  UPDATE_MATCHS_GENERAL_DATA(state, matches) {
    matches.forEach((match) => {
      if (!match) return;
      const matchIndex = state.match.list.findIndex(
        (item) => item.id === match.id,
      );
      if (matchIndex !== -1) {
        state.match.list[matchIndex] = {
          ...state.match.list[matchIndex],
          ...match,
          updated: new Date(),
        };
      } else {
        state.match.list.push({ ...match, updated: new Date() });
      }
    });
  },

  // Finished matches are NOT dropped on status: the API keeps serving them for the FT
  // retention window and stops afterwards, so isExpired alone retires them ~2 minutes
  // after the server lets them go.
  REMOVE_EXPIRED_MATCHES(state) {
    state.match.list = state.match.list.filter((match) => !isExpired(match));
  },

  SET_SEARCH_TEXT(state, text) {
    state.match.searchText = text;
  },

  SET_FILTER(state, filterKey) {
    state.match.filters[0] = MATCH_FILTER_KEYS[filterKey];
  },

  SET_SORT(state, { type, order }) {
    state.match.sort = Object.assign({}, { type, order });
  },

  TOGLE_LIVE_EXPANDED(state, id) {
    const index = state.match.liveExpanded.findIndex((row) => row === id);
    if (index >= 0) {
      state.match.liveExpanded = state.match.liveExpanded.filter(
        (_, i) => i !== index,
      );
    } else {
      state.match.liveExpanded = [...state.match.liveExpanded, id];
    }
  },

  TOGLE_TICKER_EXPANDED(state, id) {
    const index = state.match.tickerExpanded.findIndex((row) => row === id);
    if (index >= 0) {
      state.match.tickerExpanded = state.match.tickerExpanded.filter(
        (_, i) => i !== index,
      );
    } else {
      state.match.tickerExpanded = [...state.match.tickerExpanded, id];
    }
  },

  TOGLE_PREMATCH_EXPANDED(state, id) {
    const index = state.match.prematchExpanded.findIndex((row) => row === id);
    if (index >= 0) {
      state.match.prematchExpanded = state.match.prematchExpanded.filter(
        (_, i) => i !== index,
      );
    } else {
      state.match.prematchExpanded = [...state.match.prematchExpanded, id];
    }
  },

  // Единый серверный список избранного (BetsAPI matchId).
  SET_FAVORITES(state, ids) {
    state.match.favorites = (ids || []).map(Number);
  },

  TOGGLE_FAVORITE(state, id) {
    const matchId = Number(id);
    const index = state.match.favorites.indexOf(matchId);
    if (index >= 0) {
      state.match.favorites = state.match.favorites.filter(
        (_, i) => i !== index,
      );
    } else {
      state.match.favorites = [...state.match.favorites, matchId];
    }
  },
  TOGGLE_TICKER_SIGNAL_FILTER: (state, { filterKey, filterValue }) => {
    try {
      if (!state.match) throw new Error("Invalid category");

      const filters = state.match.filters;
      const index = filters.findIndex((f) =>
        typeof f === "string" ? f === filterKey : f.type === filterKey,
      );

      if (index === -1) throw new Error("Invalid filter type");

      const currentFilter = filters[index];
      const currentValue = currentFilter.value;

      if (currentValue instanceof Set) {
        const newValue = new Set(currentValue);
        newValue.has(filterValue)
          ? newValue.delete(filterValue)
          : newValue.add(filterValue);
        currentFilter.value = newValue;
      } else {
        currentFilter.value = filterValue;
      }
    } catch (error) {
      console.log(error);
    }
  },
};
